import React from 'react';
import Slider from 'react-slick';
import Fade from 'react-reveal/Fade';
import { testimonialsData } from '../data/testimonialsData';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const RatingStars = ({ rating }) => (
  <div className="d-flex gap-1 mb-3" style={{ color: '#ff4400' }}>
    {[...Array(5)].map((_, i) => (
      <svg
        key={i}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill={i < rating ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="1"
      >
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
      </svg>
    ))}
  </div>
);

export default function TestimonialsSection() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          swipe: true,
          touchMove: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          swipe: true,
          touchMove: true,
        }
      }
    ],
    swipe: true,
    touchMove: true,
    draggable: true,
    arrows: false,
  };

  return (
    <section id="testimonials" className="waya-testimonials-wrapper">
      <div className="container">
        <div className="text-center mb-5">
          <Fade bottom>
            <span className="waya-eyebrow-main" style={{ display: 'inline-block', background: 'rgba(255,68,0,0.08)', padding: '6px 16px', borderRadius: '100px', color: '#ff4400', fontWeight: '600', fontSize: '13px', marginBottom: '16px' }}>Trust & Social Proof</span>
            <h2 className="waya-section-heading">Why Nigerians Choose WayaBank</h2>
            <p className="waya-section-subline mx-auto">
              Join thousands of Nigerians who bank smarter every day.
            </p>
          </Fade>
        </div>

        <div className="testimonial-carousel-container">
          <Slider {...settings}>
            {testimonialsData.map((item) => (
              <div key={item.id} className="px-3 pb-4">
                <div className="waya-testimonial-card shadow-sm h-100" style={{ background: '#fff', borderRadius: '24px', padding: '36px', border: '1px solid rgba(0,0,0,0.05)', position: 'relative' }}>
                  <RatingStars rating={item.rating} />
                  <p className="testimonial-text mb-4" style={{ fontSize: '16px', lineHeight: '1.7', color: '#475467', fontStyle: 'italic' }}>"{item.text}"</p>
                  <div className="testimonial-author d-flex align-items-center gap-3 mt-auto">
                    <div className="author-img-box" style={{ width: '48px', height: '48px', borderRadius: '50%', overflow: 'hidden', background: '#f4f7fa', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {item.image ? (
                        <img 
                          src={item.image} 
                          alt={item.name} 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = `<span style="font-weight: 700; color: #ff4400">${item.name.charAt(0)}</span>`;
                          }}
                        />
                      ) : (
                        <span style={{ fontWeight: '700', color: '#ff4400' }}>{item.name.charAt(0)}</span>
                      )}
                    </div>
                    <div>
                      <h4 className="author-name m-0" style={{ fontSize: '16px', fontWeight: '700', color: '#101828' }}>{item.name}</h4>
                      <span className="author-source" style={{ fontSize: '13px', color: '#667085' }}>{item.role}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <style>{`
        .waya-testimonials-wrapper {
          padding: 120px 0;
          background: #ffffff;
          overflow: hidden;
        }
        .testimonial-carousel-container .slick-dots li button:before {
          color: #ff4400;
        }
        .testimonial-carousel-container .slick-dots li.slick-active button:before {
          color: #ff4400;
        }
        .waya-testimonial-card {
          transition: all 0.3s ease;
          display: flex !important;
          flex-direction: column;
        }
        .waya-testimonial-card:hover {
          transform: translateY(-8px);
          border-color: rgba(255,68,0,0.2) !important;
          box-shadow: 0 20px 48px rgba(0,0,0,0.06) !important;
        }
      `}</style>
    </section>
  );
}
